export interface iMarker {
    lineWidth: number;
    lineColor: string;
    enabled: boolean;
    symbol: string;
}

export default iMarker
export function isMarker(obj: any): obj is iMarker {
    return (
        obj &&
        typeof obj === 'object' &&
        typeof obj.lineWidth === 'number' &&
        typeof obj.lineColor === 'string' &&
        typeof obj.enabled === 'boolean' &&
        typeof obj.symbol === 'string'
    );
};